//LIBRERIE
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const TipologySearchSection: React.FC = () => {
    const { t } = useTranslation();

    const searchCategories = [
        {
            text: t('homePage.searchForTypo.typology1Text'),
            imgPath: "/assets/images/inHome/categorie/attico.webp",
            link: "immobili/attico"
        },
        {
            text: t('homePage.searchForTypo.typology2Text'),
            imgPath: "/assets/images/inHome/categorie/casaSingola.webp",
            link: "immobili/casa-singola"
        },
        {
            text: t('homePage.searchForTypo.typology3Text'),
            imgPath: "/assets/images/inHome/categorie/villa.webp",
            link: "immobili/villa"
        },
        {
            text: t('homePage.searchForTypo.typology4Text'),
            imgPath: "/assets/images/inHome/categorie/nuoveCo.webp",
            link: "immobili/?nuova-costruzione=1"
        }
    ]
        
    return (
        <section id="searchForTipology" className="space-ptb">
            <div className="container-fluid w-special">
                <p className="sub-title">{t('homePage.searchForTypo.subTitle')}</p>
                <h2 className="mb-4">{t('homePage.searchForTypo.title')}</h2>
                <div className="row">
                    {searchCategories.map(( category, index) => (
                        <div className="col-12 col-md-6 mb-4" key={index}>
                            <Link to={category.link} className="category-card" title={category.text} >
                                <img src={category.imgPath} className="img-fluid" alt={`${t('homePage.searchForTypo.altIntro') + category.text }`} />
                                <h4 className="text-center m-0">{category.text}</h4>
                                <div className="circle-shadow"></div>
                            </Link>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default TipologySearchSection;
